import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import classes from './index.module.scss';
import useWindowSize from '../../hooks/useWindowSize';
import { Button } from '@mui/material';

const TryQuestionLayout = () => {
  const [isMobile, setIsMobile] = useState(false);

  const { width: windowWidth } = useWindowSize();

  useEffect(() => {
    if (windowWidth && windowWidth < 500) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [windowWidth]);

  const handleBackClick = () => {
    let searchParams = window.location.search;
    let path = `${process.env.REACT_APP_HH_APP_ENDPOINT}/assessment/createcodingquestion${searchParams}`;
    window.location.replace(path);
  };
  return (
    <main className={classes.container}>
      <div className={classes.backgroundOne} />
      <div className={classes.backgroundTwo} />
      <section className={classes.mainContainer}>
        <div className={classes.titleContainer}>
          <div className={classes.title}>Try Question</div>
          <Button
            sx={{
              borderColor: '#fff',
              '&:hover': {
                borderColor: '#fff',
              },
              color: '#fff',
            }}
            variant="outlined"
            className={classes.back_btn}
            onClick={handleBackClick}
          >
            Back to question
          </Button>
        </div>
        <Outlet />
      </section>
    </main>
  );
};

export default TryQuestionLayout;
